import { FC } from "react";
import { Trans } from "@lingui/macro";
import { connectStats } from "react-instantsearch-dom";
import { StatsProvided } from "react-instantsearch-core";
import { DropdownInline } from "src/atoms/DropDown";
import { getSortByOptions } from "src/organisms/AlgoliaProductList/withAlgoliaState";
import { ResultContent, SortByWrapper } from "./SortByFilter.styled";
import { useLingui } from "@lingui/react";

interface Props extends StatsProvided {
  orderBy: string;
  handleSortingValue: (value: string) => void;
  mb?: number;
}

const SortByFilterComponent: FC<Props> = ({
  nbHits,
  orderBy,
  handleSortingValue,
  ...rest
}) => {
  const { i18n } = useLingui();
  return (
    <SortByWrapper {...rest}>
      {nbHits > 0 && (
        <ResultContent data-testid="total-products">
          {i18n.number(nbHits)} <Trans>results</Trans>
        </ResultContent>
      )}
      <ResultContent data-testid="products-sorting-label">
        <Trans>sort by</Trans>
      </ResultContent>
      <DropdownInline
        data-testid="product-sorting-select"
        value={orderBy || "popular"}
        options={getSortByOptions(i18n)}
        onChange={(_event: MouseEvent, { value }: { value: string }) =>
          handleSortingValue(value)
        }
      />
    </SortByWrapper>
  );
};

const SortByFilter = connectStats(SortByFilterComponent);

export default SortByFilter;
